import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import LoanData from "../../../components/loanData";
import GuaranteeInAccount from "../../../components/guaranteeInAccount";
import AccountDropDown from "../../../components/dropDown/account";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import LoadingOverlay from 'react-loading-overlay';

const CaptureGuarantee = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title="Tablero de Control \ Concertación"/>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                label="Guardar"
                                style={{'float': 'right'}}
                                onClick={props.setGuaranteePA}
                            />&nbsp;
                            <Button
                                label="Rechazar"
                                className="p-button-secondary"
                                style={{'float': 'right'}}
                                onClick={props.openConfirmationReject}
                            />&nbsp;

                            <Button label="Agregar Garantía" className="p-button-secondary"
                                    onClick={props.redirectAddInstrument}
                                    style={{'float': 'right'}}
                            /> &nbsp;
                            <Button
                                label="Regresar"
                                style={{'float': 'right'}}
                                className="p-button-secondary"
                                onClick={props.handleReturnButton}
                            />&nbsp;

                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <LoanData
                            ref={props.loanData}
                            loanId={props.loanId}
                            selectedLoan={props.selectedLoan}
                            loading={props.loading}
                            isPrecio24Hrs={true}
                        />
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={3}>
                            <SubtitleLabel header="Cuenta " isBold={true}/>
                            <AccountDropDown
                                name="catAccount"
                                filter="cuenta"
                                save={props.saveAccountTrade}
                                value={props.catAccount}
                                loading={props.loading}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <GuaranteeInAccount
                            ref={props.guaranteeInAccount}
                            loading={props.loading}
                            loanId={props.loanId}
                            maturity={props.maturity}
                            isPrecioVal={false}
                        />
                        {props.confirmationMessage}
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default CaptureGuarantee;